import { data } from '../../assets/banks';
import { Injectable } from '@angular/core';
import { MaritimebankService } from './maritimebank.service';
import { TechcombankService } from './techcombank.service';
import { SourceAccount, TargetAccount, AccountValidationResults, BankRecord } from '../interfaces/all';
import { ASCIIPipe } from '../../../../../projects/jv-common/src/public_api';

@Injectable({
  providedIn: 'root'
})
export class BankingService {

  constructor(
    private maritimebank: MaritimebankService,
    private techcombank: TechcombankService,
    private ascii: ASCIIPipe) {
  }

  // accounts used to send money to partners
  public sources: Array<SourceAccount> = [
    {
      name: 'MSB',
      globalBankName: 'MSB',
      account: '11001017958362',
      internalLimit: 5000000000,
      externalLimit: 2000000000,
      internalXLSExtractor: this.maritimebank.extractInternalXLS,
      externalXLSExtractor: this.maritimebank.extractExternalXLS
    },

    {
      name: 'TECHCOMBANK_AHA',
      globalBankName: 'TECHCOMBANK',
      account: '',
      internalLimit: 5000000000,
      externalLimit: 5000000000,
      internalXLSExtractor: this.techcombank.extractInternalXLS,
      externalXLSExtractor: this.techcombank.extractExternalXLS
    },

    {
      name: 'TECHCOMBANK_SCOOPS',
      globalBankName: 'TECHCOMBANK',
      account: '',
      internalLimit: 5000000000,
      externalLimit: 5000000000,
      internalXLSExtractor: this.techcombank.extractInternalXLS,
      externalXLSExtractor: this.techcombank.extractExternalXLS
    },
    {
      name: 'TECHCOMBANK_TRA_CAPHE_AHA',
      globalBankName: 'TECHCOMBANK',
      account: '',
      internalLimit: 5000000000,
      externalLimit: 5000000000,
      internalXLSExtractor: this.techcombank.extractInternalXLS,
      externalXLSExtractor: this.techcombank.extractExternalXLS
    }
  ];

  // accounts used to receive money from partners
  public targets: Array<TargetAccount> = [
    {
      name: 'Sacombank',
      owner: 'Nguyễn Mạnh Hà',
      account: '020008716480',
      globalBankName: 'Ngân hàng Thương mại Cổ phần Sài Gòn Thương Tín',
      globalBranchName: 'CN Hà Nội',
    },
    {
      name: 'ACB',
      owner: 'Nguyễn Mạnh Hà',
      account: '3126447',
      globalBankName: 'Ngân hàng Thương mại Cổ phần Á Châu (ACB)',
      globalBranchName: 'PGD Cửa Nam',
    },
    {
      name: 'Techcombank',
      owner: 'Nguyễn Mạnh Hà',
      account: '19027989060011',
      globalBankName: 'Ngân hàng Thương mại Cổ phần Kỹ thương Việt Nam (Techcombank)',
      globalBranchName: null
    },
    {
      name: 'VCB',
      owner: 'Nguyễn Mạnh Hà',
      account: '0011001242004',
      globalBankName: 'Ngân hàng Thương mại Cổ phần Ngoại thương Việt Nam (Vietcombank)',
      globalBranchName: null
    },
    {
      name: 'Vietinbank',
      owner: 'Nguyễn Mạnh Hà',
      account: '106870004714',
      globalBankName: 'Ngân hàng Thương mại Cổ phần Công thương Việt nam (Vietinbank)',
      globalBranchName: null
    },
    {
      name: 'BIDV',
      owner: 'Nguyễn Mạnh Hà',
      account: '12310001032490',
      globalBankName: 'Ngân hàng TMCP Đầu tư và Phát triển Việt Nam (BIDV)',
      globalBranchName: null
    },
    {
      name: 'Techcombank',
      owner: 'CÔNG TY CỔ PHẦN AHA CÀ PHÊ',
      account: '19134652686688',
      globalBankName: 'Ngân hàng Thương mại Cổ phần Kỹ thương Việt Nam (Techcombank)',
      globalBranchName: null
    },
    {
      name: 'MSB',
      owner: 'Nguyễn Mạnh Hà',
      account: '11001017958362',
      globalBankName: 'Ngân hàng MSB',
      globalBranchName: null
    },
    {
      name: 'Techcombank',
      owner: 'CÔNG TY TNHH TM VÀ DV LÂM VY',
      account: '3171179999',
      globalBankName: 'Ngân hàng Thương mại Cổ phần Kỹ thương Việt Nam (Techcombank)',
      globalBranchName: null
    },
    {
      name: 'CTY', // stand for cong ty
      owner: null,
      account: null,
      globalBankName: null,
      globalBranchName: null
    },
    {
      name: 'NH Khấu trừ', // stand for cong ty
      owner: null,
      account: null,
      globalBankName: null,
      globalBranchName: null
    }
  ];

  public validate(account: TargetAccount): AccountValidationResults {

    if (account == null) return { valid: false, transferable: false };

    if (this.ascii.transform(account.globalBankName) == 'TIEN MAT') return { valid: true, transferable: false };

    if (account.globalBankName == null || account.globalBranchName == null || account.account == null || account.owner == null || account.owner.trim().length == 0) return { valid: false, transferable: false };

    let number = account.account.trim();

    if (number.length == 0 || number != number.replace(/([^0-9])/g, '')) return { valid: false, transferable: false };

    let key = this.ascii.transform(account.globalBankName) + "/" + this.ascii.transform(account.globalBranchName);

    if (typeof data[key] == "undefined") return { valid: false, transferable: false };

    return { valid: true, transferable: true };
  }

  public getTransferInfo(from: SourceAccount, to: TargetAccount) {

    if (from == null || to == null) return null;

    let key = (this.ascii.transform(to.globalBankName) + "/" + this.ascii.transform(to.globalBranchName)).toUpperCase();
    let source = this.ascii.transform(from.globalBankName).toLowerCase();

    return typeof data[key] == "undefined" || typeof data[key][source] == "undefined" ? null : data[key][source];
  }

  public data(): Array<BankRecord> {

    let buffer = {};
    let results: Array<BankRecord> = [];

    for (let o in data) {

      let keys = o.split('/');
      if (typeof buffer[keys[0]] == "undefined") {

        buffer[keys[0]] = { bank: keys[0], branches: [] };
        results.push(buffer[keys[0]]);
      }

      buffer[keys[0]].branches.push(keys[1]);
    }

    return results;
  }


}
